import React from 'react'
import styled from 'styled-components'
import Button from 'components/Button'
import { Modal as MuiModal } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

const Modal = props => {
  const {
    title,
    children,
    withSubmit,
    withCancel,
    submitButtonText,
    cancelButtonText,
    onCancel,
    onSubmit,
    disabled,
    onClose,
    disableBackdropClose = false,
    ...muiModalProps
  } = props

  const handleModalClose = (event, reason) => {
    if (disableBackdropClose && reason === 'backdropClick') {
      return
    }
    if (typeof onClose === 'function') {
      onClose(event)
    }
  }

  return (
    <MuiModal {...muiModalProps} onClose={handleModalClose}>
      <StyledModal onClick={e => e.stopPropagation()}>
        <ModalHeader>
          <ModalTitle>{title}</ModalTitle>
          <StyledCloseIcon onClick={onClose} />
        </ModalHeader>
        {children}
        {
          (withSubmit || withCancel) && (
            <ButtonsWrapper>
              {withCancel && (
                <Button onClick={onCancel}>
                  {cancelButtonText}
                </Button>)}
              {withSubmit && (
                <SubmitButton color='primary' onClick={onSubmit} disabled={disabled}>
                  {submitButtonText}
                </SubmitButton>)}
            </ButtonsWrapper>
          )
        }
      </StyledModal>
    </MuiModal>
  )
}

Modal.defaultProps = {
  submitButtonText: 'Submit',
  cancelButtonText: 'Cancel',
  onCancel: () => {},
  onSubmit: () => {}
}

export default Modal

const StyledModal = styled.div`
  box-sizing: border-box;
  padding: 20px;
  min-width: 435px;
  background-color: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  max-height: 90vh;
  overflow-y: auto;
  transform: translate(-50%, -50%);
  border: none;
  outline: none;
  
  @media (max-width: 768px) {
    min-width: unset;
    width: 95%;
  }
`

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px;
  margin-bottom: 20px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
`

const ModalTitle = styled.div`
  font-size: 16px;
  font-weight: bold;
  opacity: .5;
`

const StyledCloseIcon = styled(CloseIcon)`
  font-size: 14px !important;
  color: ${({ theme }) => theme.colors.text};
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.colors.darkGrey};
  }
`

const ButtonsWrapper = styled.div`
  margin-top: 20px;
  padding-top: 10px;
  border-top: 1px solid ${({ theme }) => theme.colors.border};
  display: flex;
  justify-content: flex-end;
`

const SubmitButton = styled(Button)`
  margin-left: 15px !important;
`
